import { Form, FormSection } from "components/ResumeForm/Form";
import { Input } from "components/ResumeForm/Form/InputGroup";
import RichEditor from "./Form/QuillEditor";
import type { CreateHandleChangeArgsWithDescriptions } from "components/ResumeForm/types";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { selectCertificates, changeCertificates } from "lib/redux/resumeSlice";
import type { ResumeCertificate } from "lib/redux/types";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const CertificatesForm = () => {
  const certifications = useAppSelector(selectCertificates);
  const dispatch = useAppDispatch();
  const showDelete = certifications.length > 1;

  return (
    <Form form="certifications" addButtonText="Add Certificate">
      {certifications.map((item, idx) => {
        const { certificate, certificateLink, descriptions } = item;
          const handleCertificateChange = (
            ...[
              field,
              value,
            ]: CreateHandleChangeArgsWithDescriptions<ResumeCertificate>
          ) => {
            dispatch(changeCertificates({ idx, field, value } as any));
          };
          const showMoveUp = idx !== 0;
          const showMoveDown = idx !== certifications.length - 1;

          return (
            <FormSection
              key={item.id ?? idx}
              form="certifications"
              idx={idx}
              showMoveUp={showMoveUp}
              showMoveDown={showMoveDown}
              showDelete={showDelete}
              deleteButtonTooltipText={"Delete certificate"}
            >
              <Input
                name="certificate"
                label="Certificate Title"
                placeholder="Advanced Java Developer Certificate"
                value={certificate}
                onChange={handleCertificateChange}
                labelClassName="col-span-4"
              />
              <Input
                name="certificateLink"
                label="Certificate Link"
                placeholder="https://javacertificate-udemy.com"
                value={certificateLink}
                onChange={handleCertificateChange}
                labelClassName="col-span-full"
              />
              {/* <RichEditor
                name="descriptions"
                value={descriptions}
                onChange={handleCertificateChange}
                labelClassName="col-span-full"
                placeholder="Certificate Description"
              /> */}
                <RichEditorWithSuggestions
                  name="descriptions"
                  value={descriptions}
                  onChange={handleCertificateChange}
                  placeholder="Certificate Description"
                  section="certifications"
                />
            </FormSection>
          );
        }
      )}
    </Form>
  );
};
